
const digest = '28571f4132d4a83c8ec6e8631739c14c295980e97d423ca66573d39600e28eab';
const classes = {"button":"_button_hkbpr_1"};
const css = `._button_hkbpr_1 {
  position: absolute;
  width: 10px;
  height: 10px;
  top: 0;
  right: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  